<div class="container">

  <app-header-dialog [iconName]="'people_outline'">
    {{ local_title }}
  </app-header-dialog>

  <div class='content-register'>

    <mat-card>

      <div>

        <mat-form-field class="name-width" appearance="outline">
          <mat-label>Nome</mat-label>
          <input readonly matInput type="text" [formControl]="memberForm.controls.name" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="gender-width" appearance="outline">
          <mat-label>Gênero</mat-label>
          <mat-select [formControl]="memberForm.controls.sex">
            <mat-option value="M">M</mat-option>
            <mat-option value="F">F</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-checkbox class="staff-width" color='primary' [formControl]="memberForm.controls.staff">
          <span>Staff</span>
        </mat-checkbox>

        <mat-checkbox class="tester-width" color='primary' [formControl]="memberForm.controls.tester">
          <span>Tester</span>
        </mat-checkbox>

      </div>

      <div>

        <mat-form-field class="category-width" appearance="outline">
          <mat-label>Categoria*</mat-label>
          <mat-select [ngModel]='subCategorySelected_id'>
            <mat-option *ngFor="let subcat of subCategories" [value]="subcat.id">
              {{subcat.name }}
            </mat-option>
          </mat-select>

        </mat-form-field>

        <span>{{ partnerText }}</span>
        <span> - </span>
        <span *ngIf='oldCategory'>
          Antes: {{oldCategory.name}}
        </span>

      </div>

      <mat-form-field class="regional-width" appearance="outline">
        <mat-label>Regional</mat-label>
        <input matInput type="text" [formControl]="memberForm.controls.regional" autocomplete="off">
      </mat-form-field>

    </mat-card>

    <mat-card>

      <div>

        <mat-form-field class="situation-width" appearance="outline">
          <mat-label>Anuidades</mat-label>
          <mat-select [formControl]="memberForm.controls.situation">
            <mat-option *ngFor="let sit of situations" [value]="sit.value">
              {{ sit.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="situation-width" appearance="outline">
          <mat-label>Débito</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.balance" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="situation-width" appearance="outline">
          <mat-label>Crédito</mat-label>
          <input matInput type="number" [formControl]="memberForm.controls.credit" autocomplete="off">
        </mat-form-field>

      </div>

    </mat-card>

    <mat-card>
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Observação</mat-label>
        <input matInput type="text" [formControl]="memberForm.controls.obs" autocomplete="off">
      </mat-form-field>
    </mat-card>

    <mat-card>

      <div>

        <mat-form-field class="email-width" appearance="outline">
          <mat-label>E-mail</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.email" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="email-width" appearance="outline">
          <mat-label>E-mail 2</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.email2" autocomplete="off">
        </mat-form-field>

      </div>

    </mat-card>

    <mat-card>

      <div>

        <mat-form-field style="width: 70px; margin-right: 20px;" appearance="outline">
          <mat-label>Código Pais</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.cellPhonePrefix" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="phone-width" appearance="outline">
          <mat-label>Celular</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.cellPhone" autocomplete="off">
        </mat-form-field>


        <mat-form-field class="phone-width" appearance="outline">
          <mat-label>Consultório</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.clinicPhone" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="phone-width" appearance="outline">
          <mat-label>Hospital</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.hospitalPhone" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="phone-width" appearance="outline">
          <mat-label>Auxiliar</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.aux1Phone" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="phone-width" appearance="outline">
          <mat-label>Auxiliar 2</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.aux2Phone" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="phone-width" appearance="outline">
          <mat-label>Fax</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.faxPhone" autocomplete="off">
        </mat-form-field>

      </div>

    </mat-card>

    <mat-card>

      <div>

        <mat-form-field class="doc-width" appearance="outline">
          <mat-label>CPF</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.cpf" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="doc-width" appearance="outline">
          <mat-label>RG</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.rg" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="doc-width" appearance="outline">
          <mat-label>CRM</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.crm" autocomplete="off">
        </mat-form-field>

      </div>

    </mat-card>

    <mat-card>

      <div>

        <mat-form-field class="date-width" appearance="outline">
          <mat-label>Nascimento</mat-label>
          <input matInput [matDatepicker]="pickerBirth" [formControl]="memberForm.controls.dateBirth">
          <mat-datepicker-toggle matSuffix [for]="pickerBirth"></mat-datepicker-toggle>
          <mat-datepicker #pickerBirth></mat-datepicker>

        </mat-form-field>

        <mat-form-field class="date-width" appearance="outline">
          <mat-label>Filiação</mat-label>
          <input matInput [matDatepicker]="pickerFiliation" [formControl]="memberForm.controls.dateFiliation">
          <mat-datepicker-toggle matSuffix [for]="pickerFiliation"></mat-datepicker-toggle>
          <mat-datepicker #pickerFiliation></mat-datepicker>

        </mat-form-field>

        <mat-form-field class="date-width" appearance="outline">
          <mat-label>Título</mat-label>
          <input matInput [matDatepicker]="pickerTitle" [formControl]="memberForm.controls.dateTitle">
          <mat-datepicker-toggle matSuffix [for]="pickerTitle"></mat-datepicker-toggle>
          <mat-datepicker #pickerTitle></mat-datepicker>

        </mat-form-field>

        <mat-form-field class="date-width" appearance="outline">
          <mat-label>Cadastro</mat-label>
          <input matInput [matDatepicker]="pickerCreated" [formControl]="memberForm.controls.dateCreated">
          <mat-datepicker-toggle matSuffix [for]="pickerCreated"></mat-datepicker-toggle>
          <mat-datepicker #pickerCreated></mat-datepicker>

        </mat-form-field>

      </div>

    </mat-card>

    <mat-card>

      <div>

        <mat-form-field class="address-width" appearance="outline">
          <mat-label>Endereço</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.address" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="numero-width" appearance="outline">
          <mat-label>Número</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.number" autocomplete="off">
   
        </mat-form-field>

        <mat-form-field class="complemento-width" appearance="outline">
          <mat-label>Complemento</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.complement" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="cep-width" appearance="outline">
          <mat-label>CEP</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.postalCode" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="city-width" appearance="outline">
          <mat-label>Cidade</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.city" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="local-width" appearance="outline">
          <mat-label>Estado</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.state" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="local-width" appearance="outline">
          <mat-label>País</mat-label>
          <input matInput type="text" [formControl]="memberForm.controls.country" autocomplete="off">
        </mat-form-field>

      </div>

    </mat-card>

    <mat-card>

      <div class="member-image">
        <img [src]="_gn1Service.storedImage" *ngIf="_gn1Service.storedImage">
      </div>

    </mat-card>

    <mat-card>

      <ckeditor [config]="{ 
      toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
        [formControl]="memberForm.controls.text" [editor]="Editor"></ckeditor>

    </mat-card>

  </div>

</div>